// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__31hHI","inner":"Footer_inner__3cL1c","nextIcon":"Footer_nextIcon__jephV","innerLeft":"Footer_innerLeft__2XKD7"};